import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Button } from '@/components/ui'

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFF8F5] via-[#FFFEF1] to-[#F0FAFA] flex flex-col items-center justify-center px-4">
      {/* Decorative sparkles */}
      <motion.svg
        className="absolute top-20 left-8"
        width={14}
        height={14}
        viewBox="0 0 24 24"
        fill="#FF8C33"
        animate={{ scale: [1, 1.3, 1], opacity: [0.5, 0.8, 0.5], rotate: [0, 15, 0] }}
        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
      >
        <path d="M12 0L13.5 9L22 12L13.5 15L12 24L10.5 15L2 12L10.5 9L12 0Z" />
      </motion.svg>
      <motion.svg
        className="absolute top-32 right-10"
        width={10}
        height={10}
        viewBox="0 0 24 24"
        fill="#46C0C6"
        animate={{ scale: [1, 1.3, 1], opacity: [0.5, 0.8, 0.5], rotate: [0, 15, 0] }}
        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut", delay: 0.5 }}
      >
        <path d="M12 0L13.5 9L22 12L13.5 15L12 24L10.5 15L2 12L10.5 9L12 0Z" />
      </motion.svg>

      <div className="text-center max-w-md">
        {/* 404 Icon */}
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ type: 'spring', damping: 15 }}
          className="w-24 h-24 mx-auto mb-6 rounded-full bg-[#ECF9F9] flex items-center justify-center"
        >
          <span className="text-5xl">🔍</span>
        </motion.div>

        {/* Title */}
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="text-3xl font-bold text-[#075D61] mb-2"
          style={{ fontFamily: "'Anybody', sans-serif" }}
        >
          Page Not Found
        </motion.h1>

        {/* Description */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="text-gray-600 mb-8"
        >
          The page you're looking for doesn't exist or has been moved.
        </motion.p>

        {/* Back to Home Button */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <Link to="/">
            <Button size="lg" className="shadow-md">
              Back to Home
            </Button>
          </Link>
        </motion.div>
      </div>
    </div>
  )
}
